export function genreFilter() {
    const genreLinks = document.querySelectorAll('.farlo-whats-on__filters-categories__list-item-link');
    const events = document.querySelectorAll('.site-events-card');
    const otherFilterLinks = document.querySelectorAll('.farlo-whats-on__filters-links a');
    const venueContainers = document.querySelectorAll('.farlo-whats-on__venues-venue'); // Theatre containers
    const urlParams = new URLSearchParams(window.location.search);
    const currentGenres = urlParams.get('genre') ? urlParams.get('genre').split(',') : [];

    function filterEventsByGenres(genres) {
        events.forEach(event => {
            const eventGenres = event.getAttribute('data-genres') || '';
            const eventGenreList = eventGenres.split(',');

            if (genres.length === 0 || genres.some(genre => eventGenreList.includes(genre))) {
                event.style.display = '';
            } else {
                event.style.display = 'none';
            }
        });


        venueContainers.forEach(venue => {
            const eventsInVenue = venue.querySelectorAll('.site-events-card');
            const visibleEvents = Array.from(eventsInVenue).filter(event => event.style.display !== 'none');
            const container = venue.querySelector('.site-events__container');
         

            let noShowsMessage = venue.querySelector('.no-shows-message');

            if (visibleEvents.length === 0) {
                if (!noShowsMessage) {
                    noShowsMessage = document.createElement('p');
                    noShowsMessage.className = 'no-shows-message';
                    container.appendChild(noShowsMessage);
                }
                noShowsMessage.textContent = genres.length
                    ? `There are no ${genres.join(', ')} shows currently showing here.`
                    : 'There are no shows currently showing here.';
            } else if (noShowsMessage) {
                noShowsMessage.remove();
            }
        });
    }

    function updateGenreLinks(genres) {
        genreLinks.forEach(link => {
            const linkGenre = new URL(link.href).searchParams.get('genre');
            if (genres.includes(linkGenre)) {
                link.classList.add('farlo-whats-on__filters-categories__list-item-link--active');
            } else {
                link.classList.remove('farlo-whats-on__filters-categories__list-item-link--active');
            }
        });
    }

    function updateOtherFilterLinks(genres) {
        otherFilterLinks.forEach(link => {
            const url = new URL(link.href);
            if (genres.length > 0) {
                url.searchParams.set('genre', genres.join(','));
            } else {
                url.searchParams.delete('genre');
            }
            link.href = url.toString();
        });
    }

    function updateQueryString(genres) {
        const newUrl = new URL(window.location);
        if (genres.length > 0) {
            newUrl.searchParams.set('genre', genres.join(','));
        } else {
            newUrl.searchParams.delete('genre');
        }
        window.history.pushState({}, '', newUrl.toString());
    }

    genreLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const clickedGenre = new URL(link.href).searchParams.get('genre');

            const genreIndex = currentGenres.indexOf(clickedGenre);
            if (genreIndex === -1) {
                currentGenres.push(clickedGenre);
            } else {
                currentGenres.splice(genreIndex, 1);
            }

            filterEventsByGenres(currentGenres);
            updateQueryString(currentGenres);
            updateGenreLinks(currentGenres);
            updateOtherFilterLinks(currentGenres);
        });
    });

    if (currentGenres.length > 0) {
        filterEventsByGenres(currentGenres);
        updateGenreLinks(currentGenres);
        updateOtherFilterLinks(currentGenres);
    }
}
